"use client";

import { newsContextSchema, NewsContext } from "@vereinsheim/backend-types/src/news";
import { getDateWithDayLong, getTime } from "@/helpers/dateHelper";
import Link from "next/link";
import {
  pwaOvNewsPath,
  pwaOvNewsTeamPath
} from "@/utils/urlHelper";
import { useTeam } from "@/app/pwa/lib/pwa-context";
import { OvNews } from "@/sources/kicker-ovsyndication";
import Image from "../../components/Image";

type NewsElementProps = {
  news: OvNews,
  className?: string,
  teamName?: string,
  contextId:string,
  listContext?: NewsContext
};

export function OvNewsElement(
  {
    news,
    className,
    contextId,
    listContext
  }: NewsElementProps) {
  const team = useTeam(listContext === newsContextSchema.enum.Team ? parseInt(contextId) : undefined);
  return (
    
      <Link href={listContext == "Club" ? pwaOvNewsPath(news.id, encodeURIComponent(news.title)) : pwaOvNewsTeamPath(news.id, contextId, news.title)} className={`block interactive-cell ${className}`}>
        <div className="flex gap-4">
          <div className=" flex-shrink-0 min-w-24 w-1/5 max-w-[256]">
          {news.imageModul && 
            <Image width={256} height={256} alt={""} src={news.imageModul} className="w-full rounded" />
          }
          
          </div>
          <div className="flex flex-col">
            <h4 className="text-lg font-semibold">{news.title}</h4>
         
            <div className="font-normal hidden @sm:block">
              {news.teaser}
            </div>
            <div className="flex justify-between items-baseline">
            <time className="text-muted"
                  dateTime={new Date(news.date).toISOString()}>{getDateWithDayLong(news.date)}, {getTime(news.date)}</time>
            <div className="flex-grow hidden @md:block w-0"></div>
            </div>
          </div>
        </div>

      </Link>
    
  
  )
}
